import { AppError } from './app-error'

export class ConflictError extends AppError {
  private static NAME: string = 'ConflictError'
  public static MESSAGE: string = 'Há um conflito para realizar essa operação.'

  constructor(message?: string | null, title?: string | undefined) {
    super(ConflictError.NAME, message ?? ConflictError.MESSAGE, title)
  }
}
